module.exports = __webpack_public_path__ + "img/dindin_code.7426946.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/dindin_code.png
// module id = VDrf
// module chunks = 23 24